import React from "react";
import Button from "@material-ui/core/Button";
import classNames from "classnames";
import PlayerFormat from "../../util/player-format";
import gameButtonStyles from "../football/styles/GameButton.styles";

const PlayerButton = ({ player, selected, disabled, onClick, teamColor }) => {
	const { uniform, positions } = player;
	const { name: positionName, code: positionCode } = positions?.[0] || {};
	const classes = gameButtonStyles({
		selected,
		disabled,
		positionCode,
		teamColor
	});

	return (
		<Button
			title={positionName}
			id={`player-${player.uniform}`}
			onClick={() => onClick(player)}
			variant="outlined"
			className={classNames(classes.root, classes.playerButton)}
			disabled={!selected && disabled}
			aria-pressed={selected}
		>
			{PlayerFormat.getUniformNormalized(uniform)} {positionCode}
		</Button>
	);
};

export default PlayerButton;
